<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.6 0C14.9021 0 19.2 4.29792 19.2 9.6C19.2 14.9021 14.9021 19.2 9.6 19.2C4.29792 19.2 0 14.9021 0 9.6C0 4.29792 4.29792 0 9.6 0ZM13.8643 5.76C13.4986 5.76672 12.937 5.95872 10.2365 7.06752C8.34095 7.85885 6.45066 8.66271 4.56576 9.47904C4.10496 9.66048 3.86496 9.83712 3.84288 10.0099C3.80064 10.3421 4.28448 10.4448 4.89312 10.6406C5.38944 10.8 6.0576 10.9862 6.40512 10.9939C6.72 11.0006 7.07136 10.872 7.4592 10.6099C10.1088 8.84352 11.4749 7.95168 11.5613 7.93248C11.6218 7.91904 11.7053 7.90176 11.7629 7.95168C11.8195 8.0016 11.8138 8.09568 11.807 8.1216C11.759 8.32416 9.27168 10.5581 9.12864 10.705L9.05952 10.7741C8.53152 11.2954 7.99872 11.6362 8.9184 12.2342C9.74976 12.7747 10.2336 13.1194 11.088 13.6742C11.6352 14.0275 12.0643 14.447 12.6288 14.3962C12.889 14.3722 13.1568 14.1312 13.2941 13.4112C13.6157 11.712 14.2493 8.02752 14.3952 6.5088C14.404 6.38283 14.3985 6.25626 14.3789 6.13152C14.367 6.03081 14.3177 5.93826 14.2406 5.87232C14.1245 5.77824 13.944 5.75904 13.8643 5.76Z"
            :fill="color" />
    </svg>
</template>
<script>
export default {
    name: "TelegramIcon",
    props: {
        color: {
            type: String,
            default: "#3A3F48",
        },
    },
};
</script>
<style scoped>
</style>
